module.exports = __webpack_public_path__ + "static/img/1.8d676992.jpg";